// Define smooth scroll behavior for anchor links
export default async function scrollBehavior(to, from, savedPosition) {
	if (savedPosition) {
		if ($nuxt?.$scroller?.scrollTo) $nuxt.$scroller.scrollTo(savedPosition)
		return savedPosition
	}
	if (to.hash) {
		const target = document.getElementById(to.hash);
		if (target) {
			window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY, behavior: 'smooth'})
		}
		return
	}
}
